import {useConfig} from '@aboutyou/config';
import {GetRecommendationsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.types';
import {BasketSection, mediaMobileOnly} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {FullHeightProductTile} from '../../../features/ProductTile/FullHeightProductTile';
import {AddToBasketPayload} from '../../../features/ProductTile/types';
import {RecommendationsLane} from '../../../features/Recommendations/RecommendationsLane';
import {getTrackFeatureLabel} from '../../../features/Recommendations/trackFeatureLabels';

export interface RecommendationsViewProps {
  items: GetRecommendationsResponse[];
  onClickAddToBasket: (tile?: AddToBasketPayload) => void;
  compactMode?: boolean;
}

export const RecommendationsView: React.FC<RecommendationsViewProps> = ({
  items,
  onClickAddToBasket,
  compactMode,
}) => {
  const {device} = useConfig();

  return (
    <>
      {items.map((item, idx) => {
        switch (item.recommendation?.type?.$case) {
          case 'products': {
            const {products, headline, subline, promotionTracking} =
              item.recommendation.type.products;

            return (
              <BasketSection key={`products-${idx}`}>
                <StyledRecommendationsLane
                  uniqueKey={`basket-reco-${idx}`}
                  type="list"
                  headline={headline}
                  constrained={compactMode}
                  topline={subline}
                  streamPosition={idx}
                  products={products}
                  promotionTracker={{
                    promotionId: promotionTracking.name,
                    promotionName: promotionTracking.name,
                    creativeName: promotionTracking.name,
                    creativeSlot: String(idx),
                    locationId: 'basket_recommendations',
                  }}
                  onAddToBasketCtaClick={
                    onClickAddToBasket
                      ? ({productId, couponPromotionId}) => {
                          const payload: AddToBasketPayload = {
                            product: {id: productId},
                            couponPromotionId,
                            badgesListKeys: [],
                          };
                          onClickAddToBasket(payload);
                        }
                      : undefined
                  }
                  trackComponentConfig={{
                    location_id: 'basket_page_recommendations',
                    page_type_id: 'basket',
                  }}
                  featureTrackingLabel={getTrackFeatureLabel(
                    promotionTracking.name,
                  )}
                  featureGenericClickLabel="adpReco"
                  enableGridLayout
                  centered
                  hideSideButtons={compactMode}
                  showDivider={compactMode}
                  productTileConfig={{
                    gridColumns: device === 'desktop' ? 4 : 2,
                  }}
                  data-testid={`basketRecoLane-${idx}`}
                  ProductTileComponent={FullHeightProductTile}
                />
              </BasketSection>
            );
          }
        }
        return null;
      })}
    </>
  );
};

const StyledRecommendationsLane = styled(RecommendationsLane)`
  &&& {
    padding-block: 3rem;
  }

  @media ${mediaMobileOnly} {
    &&& {
      padding-block: 0;
    }
  }
`;
